'use client'

import { MouseEvent, RefObject, useCallback } from 'react'

/**
 * Builds the `<dialog>` click handler that closes when the backdrop (the area outside the card —
 * i.e. the dialog element itself) is clicked. A no-op unless `enabled`.
 */
export const useBackdropClose = (
    dialogRef: RefObject<HTMLDialogElement>,
    onClose: () => void,
    enabled = false,
) =>
    useCallback(
        (event: MouseEvent<HTMLDialogElement>) => {
            if (enabled && event.target === dialogRef.current) {
                onClose()
            }
        },
        [dialogRef, onClose, enabled],
    )
